import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, Star, Gift, Smile, Flower2, Music, Coffee, Sparkles, Moon, Sun, Flame, Crown } from 'lucide-react';

const QuickLinks = () => {
  const navigate = useNavigate();

  const mainCollections = [
    {
      title: 'Popular Collections',
      links: [
        {
          title: '1000 Hearts',
          icon: Heart,
          description: 'Beautiful heart emojis',
          path: '/hearts-1000',
          emoji: '❤️',
          gradient: 'from-pink-500 to-rose-500'
        },
        {
          title: '1000 Butterflies',
          icon: Flower2,
          description: 'Flutter with butterflies',
          path: '/butterfly-1000',
          emoji: '🦋',
          gradient: 'from-purple-500 to-pink-500'
        },
        {
          title: '1000 Stars',
          icon: Star,
          description: 'Shine bright with stars',
          path: '/star-1000',
          emoji: '⭐',
          gradient: 'from-yellow-500 to-amber-500'
        },
        {
          title: '1000 Fire Emojis',
          icon: Flame,
          description: 'Express intensity',
          path: '/fire-1000',
          emoji: '🔥',
          gradient: 'from-orange-500 to-red-500'
        }
      ]
    },
    {
      title: 'Nature & Space',
      links: [
        {
          title: '1000 Moons',
          icon: Moon,
          description: 'Beautiful moon emojis',
          path: '/moon-1000',
          emoji: '🌙',
          gradient: 'from-indigo-500 to-blue-500'
        },
        {
          title: '1000 Suns',
          icon: Sun,
          description: 'Bright sun emojis',
          path: '/sun-1000',
          emoji: '☀️',
          gradient: 'from-yellow-500 to-orange-500'
        },
        {
          title: '1000 Sparkles',
          icon: Sparkles,
          description: 'Add magic & sparkle',
          path: '/sparkles-1000',
          emoji: '✨',
          gradient: 'from-purple-500 to-pink-500'
        },
        {
          title: '1000 Rainbows',
          icon: Gift,
          description: 'Colorful rainbows',
          path: '/rainbow-1000',
          emoji: '🌈',
          gradient: 'from-red-500 to-violet-500'
        }
      ]
    },
    {
      title: 'Food & Celebrations',
      links: [
        {
          title: '1000 Party Emojis',
          icon: Music,
          description: 'Time to celebrate',
          path: '/party-1000',
          emoji: '🎉',
          gradient: 'from-violet-500 to-purple-500'
        },
        {
          title: '1000 Pizza Emojis',
          icon: Coffee,
          description: 'Delicious pizzas',
          path: '/pizza-1000',
          emoji: '🍕',
          gradient: 'from-red-500 to-orange-500'
        },
        {
          title: '1000 Cake Emojis',
          icon: Gift,
          description: 'Sweet celebrations',
          path: '/cake-1000',
          emoji: '🎂',
          gradient: 'from-pink-500 to-red-500'
        },
        {
          title: '1000 Ice Creams',
          icon: Coffee,
          description: 'Cool treats',
          path: '/ice-cream-1000',
          emoji: '🍦',
          gradient: 'from-blue-500 to-purple-500'
        }
      ]
    },
    {
      title: 'Expressions & Emotions',
      links: [
        {
          title: '1000 Kiss Emojis',
          icon: Heart,
          description: 'Show your love',
          path: '/kiss-1000',
          emoji: '💋',
          gradient: 'from-red-500 to-pink-500'
        },
        {
          title: '1000 Laugh Emojis',
          icon: Smile,
          description: 'Express joy',
          path: '/laugh-1000',
          emoji: '😂',
          gradient: 'from-yellow-500 to-orange-500'
        },
        {
          title: '1000 Crown Emojis',
          icon: Crown,
          description: 'Feel royal',
          path: '/crown-1000',
          emoji: '👑',
          gradient: 'from-yellow-500 to-amber-500'
        },
        {
          title: '1000 Clap Emojis',
          icon: Star,
          description: 'Show appreciation',
          path: '/clap-1000',
          emoji: '👏',
          gradient: 'from-green-500 to-teal-500'
        }
      ]
    }
  ];

  return (
    <div className="space-y-12 mb-12">
      {mainCollections.map((collection, sectionIndex) => (
        <div key={sectionIndex}>
          <h2 className="text-2xl font-bold text-indigo-600 mb-6">{collection.title}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {collection.links.map((link, index) => (
              <div
                key={index}
                onClick={() => navigate(link.path)}
                className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer transform hover:-translate-y-1"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${link.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      <link.icon className="w-6 h-6 text-indigo-600 mr-2" />
                      <span className="text-2xl">{link.emoji}</span>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                      <svg className="w-4 h-4 text-indigo-600 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {link.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {link.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickLinks;